import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CrosshairIcon, HeartPulseIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function SolutionSection() {
  return <section id="solucion" className="py-16 md:py-24 bg-[#000000] border-t border-white/5" data-id="element-261">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-263">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-264">
            Protocolo de Tratamiento —{' '}
            <span className="text-[#FFD700] drop-shadow-[0_0_8px_rgba(255,215,0,0.3)]" data-id="element-265">
              Doctor Ecommerce
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-[#C0C0C0]" data-id="element-266">
            Operamos con precisión quirúrgica para revivir tu flujo de clientes.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-267">
          {/* Pillar 1 */}
          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-8 rounded-2xl border border-white/10 hover:border-[#50C878] transition-all duration-300 group neon-glow-hover" data-id="element-268">
            <div className="w-14 h-14 bg-[#50C878]/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-[0_0_15px_rgba(80,200,120,0.1)] group-hover:shadow-[0_0_20px_rgba(80,200,120,0.3)]" data-id="element-269">
              <ShieldCheckIcon className="w-7 h-7 text-[#50C878]" data-id="element-270" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4 group-hover:text-[#50C878] transition-colors" data-id="element-271">
              Sutura de Fugas de Dinero
            </h3>
            <p className="text-[#C0C0C0] leading-relaxed" data-id="element-272">
              Landing Pages en{' '}
              <span className="text-white font-semibold" data-id="element-273">Dark Mode</span>{' '}
              optimizadas para que el cliente llame en 3 segundos.
            </p>
          </motion.div>

          {/* Pillar 2 */}
          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-8 rounded-2xl border border-white/10 hover:border-[#50C878] transition-all duration-300 group relative overflow-hidden neon-glow-hover" data-id="element-274">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#50C878]/5 rounded-full blur-2xl -mr-16 -mt-16 group-hover:bg-[#50C878]/10 transition-colors" data-id="element-275"></div>
            <div className="w-14 h-14 bg-[#50C878]/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 relative z-10 shadow-[0_0_15px_rgba(80,200,120,0.1)] group-hover:shadow-[0_0_20px_rgba(80,200,120,0.3)]" data-id="element-276">
              <CrosshairIcon className="w-7 h-7 text-[#50C878]" data-id="element-277" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4 relative z-10 group-hover:text-[#50C878] transition-colors" data-id="element-278">
              Inyección de Tráfico
            </h3>
            <p className="text-[#C0C0C0] leading-relaxed relative z-10" data-id="element-279">
              Anuncios que solo aparecen cuando el termostato de tu cliente
              marca <span className="text-[#FFD700] font-bold" data-id="element-280">90°F</span>.
            </p>
          </motion.div>

          {/* Pillar 3 */}
          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-8 rounded-2xl border border-white/10 hover:border-[#50C878] transition-all duration-300 group neon-glow-hover" data-id="element-281">
            <div className="w-14 h-14 bg-[#50C878]/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-[0_0_15px_rgba(80,200,120,0.1)] group-hover:shadow-[0_0_20px_rgba(80,200,120,0.3)]" data-id="element-282">
              <HeartPulseIcon className="w-7 h-7 text-[#50C878]" data-id="element-283" />
            </div>
            <h3 className="text-xl font-bold text-white mb-4 group-hover:text-[#50C878] transition-colors" data-id="element-284">
              Desfibrilador de Ventas
            </h3>
            <p className="text-[#C0C0C0] leading-relaxed" data-id="element-285">
              Si el cliente no agenda, nuestro sistema de seguimiento automático
              lo <span className="text-white font-semibold" data-id="element-286">"revive"</span>{' '}
              hasta que conteste.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}